import React, { FC, useEffect, useState } from 'react';
import { TableComponent } from '../TableComponent';
import { SectionWrapper } from '../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { ButtonComponent } from '../ButtonComponent';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { AddNewAgent } from './AddNewAgent';
import { IAgent } from '../../constants/new-agent/new-agent-form';
import { AgentsTableRow } from './AgentsTableRow';
import { fetchAgencyList } from '../../store/merchnts/actions/agents';
import { useParams } from 'react-router-dom';

const AGENTS_COLUMNS = [
	// {
	// 	key: 'id',
	// 	title: 'Id',
	// 	additionalColumnClassName: 'id-width',
	// 	isDetailsPage: true
	// },
	{
		key: 'name',
		title: 'Name',
		// additionalColumnClassName: 'w-200px',
		isDetailsPage: true
	},
	{
		key: 'contactName',
		title: 'Role',
		// additionalColumnClassName: 'w-200px',
		isDetailsPage: true
	},
	{
		key: 'email',
		title: 'PARTNERS.EMAIL',
		// additionalColumnClassName: 'w-400px',
		isDetailsPage: true
	},
	{
		key: 'phone',
		title: 'PARTNERS.PHONE',
		// additionalColumnClassName: 'w-200px',
		isDetailsPage: true
	},
	{
		key: 'status',
		title: 'PARTNERS.STATUS',
		// additionalColumnClassName: 'w-150px',
		isDetailsPage: false
	},
	{
		key: 'actions',
		title: 'PARTNERS.ACTIONS',
		additionalColumnClassName: 'w-150px',
		isDetailsPage: false
	}
];

export const SalesAgentsList: FC = () => {
	const { t } = useTranslation();
	const { id } = useParams();
	const { merchantState: { agenciesList, isAgenciesListLoading }, dispatch } = useMerchants();
	const [chosenSalesAgent, setChosenSalesAgent] = useState<IAgent | null>(null);
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const tableData = agenciesList?.find(el => el?.id === id);

	useEffect(() => {
		void fetchAgencyList(dispatch);
	}, []);

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	const handleSuccess = (): void => {
		setIsModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: chosenSalesAgent?.id ? t('AGENCY.MODAL_TITLE_EDIT_SALES_AGENT') : t('AGENCY.MODAL_TITLE_SALES_AGENT'),
			content: (
				<div className="fs-6">
					{
						chosenSalesAgent?.id
							? t('AGENCY.MODAL_TEXT_EDIT_SALES_AGENT')
							: t('AGENCY.MODAL_TEXT_SALES_AGENT')
					}
				</div>
			),
			minHeight: 100,
			confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
			onConfirm: closeModal,
			onClose: closeModal
		});
	};

	const errorModal = (): void => {
		setIsModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: chosenSalesAgent?.id ? t('AGENCY.MODAL_TITLE_EDIT_SALES_AGENT') : t('AGENCY.MODAL_TITLE_SALES_AGENT'),
			content: (
				<div className="fs-6">
					{
						chosenSalesAgent?.id
							? 'Failed saving new sales agent!'
							: 'Failed creating new sales user!'
					}

				</div>
			),
			minHeight: 100,
			confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
			onConfirm: (): void => {
				closeModal();
				setIsModalOpen(true);
			},
			onClose: closeModal
		});
	};

	const addNewSalesAgentBtn = (
		<ButtonComponent
			buttonName={t('AGENCY.SALES_BTN_NAME')}
			onButtonClick={(): void => setIsModalOpen(true)}
			// additionalClass="btn-sm"
		/>
	);

	const onEdit = (admin): void => {
		setChosenSalesAgent(admin);
		setIsModalOpen(true);
	};

	return (
		<>
			<SectionWrapper
				title={t('AGENCY.SALES_AGENTS')}
				sectionAdditionalClass="mb-5 min-height-200"
				pageLoading={isAgenciesListLoading}
				headerAdditionalBlock={addNewSalesAgentBtn}
			>
				<TableComponent
					column={AGENTS_COLUMNS}
					tableData={tableData?.salesAgents}
					// tableMinHeight={tableData.length ? '' : 'table-min-height'}
					getRowComponent={(agent): JSX.Element => (
						<AgentsTableRow
							{...agent}
							key={agent?.id}
							onEdit={onEdit}
						/>
					)}
				/>
			</SectionWrapper>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
			<ModalWindow
				isOpen={isModalOpen}
				backdrop="static"
				onClose={(): void => setIsModalOpen(false)}
				modalTitle={chosenSalesAgent?.id ? t('AGENCY.MODAL_TITLE_EDIT_SALES_AGENT') : t('AGENCY.MODAL_TITLE_SALES_AGENT')}
				content={
					<AddNewAgent
						setChosenAgent={setChosenSalesAgent}
						agent={chosenSalesAgent}
						onSuccess={handleSuccess}
						onError={errorModal}
						onCancel={(): void => setIsModalOpen(false)}
					/>
				}
			/>
		</>

	);
};
